var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mainWrapper" },
        [
          _c("ActivityTracker"),
          _c("TopBar"),
          _c("NavigationBar"),
          _vm._t("default"),
        ],
        2
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }